export default from './LabelWithBadge';



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/components/Tabs/components/LabelWithBadge/index.js